export default __webpack_public_path__ + "static/media/ZoomIn.b6f365f1.svg";